export const logAddPersonalisedMessage = (isPlantPot: boolean) => {
  global.dataLayer.push({
    event: isPlantPot ? 'add_personalised_message_engraving' : 'add_personalised_message_engraving_pot_pdp',
  });
};

export const logAddPersonalisedDate = (isPlantPot: boolean) => {
  global.dataLayer.push({
    event: isPlantPot ? 'add_personalised_date_engraving' : 'add_personalised_date_engraving_pot_pdp',
  });
};
